export default __webpack_public_path__ + "static/media/ocado-logo.6cbb770f.svg";